import React from 'react';
import { Navigate, Link } from 'react-router-dom';
import { createBrowserHistory } from "history";
import { connect } from "react-redux";
import AuthApi from "../../../assets/js/utils/Auth";
import Config from "../../../../Config";
import Api from "../../../assets/js/utils/Api";
import { helper } from "../../../assets/js/utils/Element";
import Cookie from "../../../assets/js/utils/Cookie";
import PasswordMatch from "../../../assets/js/utils/PasswordMatch";
import LoaderComponent from '../../components/Loader'
import CustomInput from "../../components/CustomInput/CustomInput.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
// import InfoArea from "../../components/InfoArea/InfoArea.jsx";
import InputAdornment from "@mui/material/InputAdornment";
// import Checkbox from "@mui/material/Checkbox";
// import FormControlLabel from "@mui/material/FormControlLabel";
import Warning from "../../components/Typography/Warning.jsx";
import Snackbar from '@mui/material/Snackbar';
import LockIcon from "@mui/icons-material/Lock";
// import RecaptchaV2 from "../../components/Google/RecaptchaV2";
// import MaterialLink from "@mui/material/Link";
// import { ReactComponent as AmazonIcon } from "../../../assets/icons/amazon.svg";
// import { ReactComponent as GoogleIcon } from "../../../assets/icons/google.svg";
// import { ReactComponent as FacebookIcon } from "../../../assets/icons/facebook2.svg";
import { mapStateToProps } from "../../../store/reducers/rootReducer";
import InactiveUserModal from "../../components/Modals/InactiveUserModal";

// @mui/icons-material
// import Timeline from "@mui/icons-material/Timeline";
// import Code from "@mui/icons-material/Code";
// import Group from "@mui/icons-material/Group";
import Email from "@mui/icons-material/Email";
// import Check from "@mui/icons-material/Check";
import AuthIcon from "@mui/icons-material/Lock";
import VerifiedUser from "@mui/icons-material/VerifiedUser";
import { styled } from '@mui/material/styles';
import { signupPageStyle, classes } from "../../../assets/jss/material-kit-pro-react/views/signupPageStyle.jsx";
const SignupRoot = styled('div')(({ theme }) => signupPageStyle(theme));
const history = createBrowserHistory();

const Signup = class extends React.Component {
    constructor(props){
        super(props);

        this.history = this.props.history;
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.resendCode = this.resendCode.bind(this);
        this.confirmSignUp = this.confirmSignUp.bind(this);
        this.codeResendNotice = this.codeResendNotice.bind(this);
        this.emailRef = React.createRef();
        this.nameRef = React.createRef();

        this.email = Math.random().toString(36).slice(-8);
        this.password = Math.random().toString(36).slice(-8);
        this.passwordConfirm = Math.random().toString(36).slice(-8);

        this.redirecting = false;
        if(Config.isHostedAuthEnabled()){
            const searchQuery = window.location.search;
            if(typeof(searchQuery) === "string" && searchQuery.length > 1){
                this.redirecting = true;
            }

            const code = helper.getParam("code");    
            if(code && code.length > 0 && code !== "null"){
                this.redirecting = false;
            }

            const href = window.location.href;
            const { authorized } = this.props.state;
            if(this.redirecting && !authorized && href.indexOf("/user/onboarding") === -1){
                localStorage.setItem("mogli_query_params", searchQuery);
                setTimeout(() => {
                    window.location.href = Config.getSignupUrl("/signup");
                },3000);
            }
        }

        this.state = {
            [this.email]: "",
            [this.password]: "",
            [this.passwordConfirm]: "",
            code: "",
            loading: false,
            // terms: false,
            validation: {
                email: '',
                password: '',
                passwordConfirm: '',
                code: '',
                // terms: '',
                isValid: false
            },
            requireLowerletter: false,
            requireUpperletter: false,
            requireNumber: false,
            requireSymbol: false,
            requireLength: false,
            requestCode: false,
            showError: false,
            errorMessage: "",
            codeResendNotice: false,
            showRecaptcha: false,
            botDetected: false,
            inactiveUserModal: false,
            redirect: false,
            redirectUrl: null
        };
    }
    componentDidMount(){
        const that = this;
        const code = helper.getParam("code");    
        if(code && code.length > 0 && code !== "null"){
            this.setState({loading: true});
            AuthApi.validateCode(code, Config.getRedirectUri("/signup")).then(data => {
                AuthApi.updateTokens(data,true);
                that.getUserInfo(true);   
            }).catch(err => {
                console.log(err);
                this.setState({loading: false});
            });

            const searchQuery = localStorage.getItem("mogli_query_params");
            const queryParams = Cookie.read("query_params");
            if(searchQuery !== null){
                history.push("/signup"+searchQuery);
            }else if(queryParams !== null && queryParams !== "null"){
                history.push("/signup"+queryParams);
            }
            localStorage.removeItem("mogli_query_params");
            Cookie.dispose("query_params");
        }
    }
    getUserInfo(login = false){
        const that = this;
        AuthApi.getUserInfo(function(data){
            const redirectUrl = "/"+window.location.search;
            that.handleUserInfo(data, login, redirectUrl);
        },function(err){
            if(err.response !== 'undefined'){
                AuthApi.logout();
                this.props.dispatch({type: 'LOGOUT'});
            }else{
                this.props.dispatch({type: 'LOGOUT'});
            }
        });
    }
    handleUserInfo(data, login = false, redirectUrl = "/"){
        const that = this;
        if(data.numberOfResponses > 0){
            data.response.map(user => {
                let actionType = 'UPDATE_STATE';
                if(login){
                    that.history.push(redirectUrl);
                    actionType = 'LOGIN';
                }
                user = Api.prepareMemberObject(user);
                if(user.hasOwnProperty("IsActive__c") && !user.IsActive__c){
                    AuthApi.logout();
                    that.setState({
                        inactiveUserModal: true
                    });
                    return null;
                }
                // var fullName = "";
                // if(user.hasOwnProperty("firstName")){
                //     fullName = user.firstName;
                // }
                // if(user.hasOwnProperty("lastName")){
                //     fullName += " "+user.lastName;
                // }

                // try{
                //     if('FS' in window){
                //         window.FS.identify(user.userId, {
                //             displayName: fullName.trim(),
                //             email: user.userEmail,
                //             userId: user.userId
                //         });
                //     }
                // }catch(e){  }

                this.props.dispatch({
                    type: actionType,
                    state: {
                        authorized: true,
                        user: user
                    }
                });
                
                return null;
            });
        }
    }
    handleChange(e, name){
        let state = {};
        state[name] = e.target.value;
        if(name === this.email){
            state[name] = e.target.value.toLowerCase();
        }

        //Honeypot fix for actual signup
        if(name === this.email || name === this.password || name === this.passwordConfirm){
            this.emailRef.current.value = "";
            this.nameRef.current.value = "";
        }

        this.setState(state);
    }
    handleCheckbox(e, name){
        let state = {};
        state[name] = e.target.checked;
        this.setState(state);
    }
    componentDidUpdate(prevProps, prevState){
        // const { terms } = this.state;
        const email = this.state[this.email];
        const password = this.state[this.password];
        const passwordConfirm = this.state[this.passwordConfirm];

        const prevEmail = prevState[this.email];
        const prevPassword = prevState[this.password];
        const prevPasswordConfirm = prevState[this.passwordConfirm];

        let validateEmail = false;
        let validatePassword = false;
        let validatePasswordConfirm = false;
        if(prevEmail !== email){
            validateEmail = true;
        }
        if(prevPassword !== password){
            validatePassword = true;
            validatePasswordConfirm = true;
        }
        if(prevPasswordConfirm !== passwordConfirm){
            validatePasswordConfirm = true;            
        }
        if(validateEmail || validatePassword || validatePasswordConfirm 
            // || terms !== prevState.terms
        ){
            this.validateForm(validateEmail, validatePassword, validatePasswordConfirm);
        }
    }
    handleSubmit(e){
        e.preventDefault();
        const isValid = this.validateForm(true, true, true);
        if(!isValid || this.state.loading){
            return;
        }
        if(Config.isRecaptchaEnabled()){
            this.setState({showRecaptcha: true});
            return;
        }
        if(this.isBotDetected()){
            this.setState({botDetected: true});
            return;
        }
        const email = this.state[this.email];
        const password = this.state[this.password];
        AuthApi.signUp(email, password, this);
        this.setState({loading: true, showError: false});
    }
    validateForm(validateEmail = false, validatePassword = false, validatePasswordConfirm = false){
        let validation = {
            email: (validateEmail ? 'success': this.state.validation.email),
            password: (validatePassword ? 'success': this.state.validation.password),
            passwordConfirm: (validatePasswordConfirm ? 'success': this.state.validation.passwordConfirm),
            // terms: 'success',
            isValid: true
        };
        const email = this.state[this.email];
        const password = this.state[this.password];
        const passwordConfirm = this.state[this.passwordConfirm];

        var emailRegex = /\S+@\S+\.\S+/;
        if(validateEmail && (email.length <= 0 || !emailRegex.test(email))){
            if(validateEmail){
                validation.email = "error";
            }
            validation.isValid = false;
        }
        
        const that = this;
        const check = PasswordMatch.check(password,function(requireLowerletter, requireUpperletter, requireNumber, requireSymbol, requireLength){
            that.setState({
              showPasswordErrors: true,
              requireLowerletter: requireLowerletter,
              requireUpperletter: requireUpperletter,
              requireNumber: requireNumber,
              requireSymbol: requireSymbol,
              requireLength: requireLength
            });
        });
        if(password.length <= 0 || check === false){
            if(validatePassword){
                validation.password = "error";
            }
            validation.isValid = false;
        }

        if(passwordConfirm.length <= 0 || password !== passwordConfirm){
            if(validatePasswordConfirm){
                validation.passwordConfirm = "error";
            }
            validation.isValid = false;
        }else if(passwordConfirm.length > 0 && password === passwordConfirm){
            if(validation.password === "success"){
                validation.passwordConfirm = "success";
            }
        }

        // if(this.state.terms === false){
        //     validation.terms = "error";
        //     validation.isValid = false;
        // }

        this.setState({validation: validation});
        return validation.isValid;
    }
    onValidateSuccess(){
        // const email = this.state[this.email];
        this.setState({loading: false, requestCode: true});
        let url = "/signup/verification"+window.location.search;
        history.push(url);
        setTimeout(() => {
            window.scrollTo(0, 0);
        },200);
    }
    onValidateConfirmSuccess(data){
        const email = this.state[this.email];
        const password = this.state[this.password];
        const that = this;
        AuthApi.signIn(email, password, {
            onValidateSuccess: function(data){
                if(data.numberOfResponses > 0){
                    const user = Api.prepareMemberObject(data.response[0]);
                    if(user.hasOwnProperty("IsActive__c") && !user.IsActive__c){
                        AuthApi.logout();
                        that.setState({
                            inactiveUserModal: true
                        });
                        return null;
                    }
                    try{
                        setTimeout(function(){
                            var fullName = "";
                            if(user.hasOwnProperty("firstName")){
                                fullName = user.firstName;
                            }
                            if(user.hasOwnProperty("lastName")){
                                fullName += " "+user.lastName;
                            }
                            
                            if('FS' in window){
                                window.FS.identify(user.userId, {
                                    displayName: fullName.trim(),
                                    email: user.userEmail,
                                    userId: user.userId
                                });
                            }
                        },1000);
                    }catch(e){  }
                    
                    let url = "/"+window.location.search;
                    that.history.push(url);
                    this.props.dispatch({
                        type: "LOGIN",
                        state: {
                            authorized: true,
                            user: user
                        }
                    });                    
                }
            },
            onValidateFail: function(err){
                that.history.push("/login");
            }
        });
    }
    onValidateFail(err){
        let errorMessage = "";
        if(typeof(err) === "string"){
            errorMessage = err;
        }else{
            errorMessage = err.message;
        }
        this.setState({
            loading: false,
            showError: true,
            errorMessage: errorMessage
        });
    }
    resendCode(event){
        event.preventDefault();
        event.stopPropagation();
        this.setState({codeResendNotice: true});
        const email = this.state[this.email];
        AuthApi.resendSignUp(email,this);
    }
    confirmSignUp(event){
        event.preventDefault();
        event.stopPropagation();
        if (this.state.code.length <= 0) {
            this.setState({
                ...this.state,
                validation: {
                    ...this.state.validation,
                    code: "error"
                }
            });
            return;
        }
        const email = this.state[this.email];
        const code = this.state.code;
        this.setState({loading: true, showError: false});
        AuthApi.confirmSignUp(email,code,this);
    }
    codeResendNotice(open){
        this.setState({codeResendNotice: open});
    }
    onRecaptcha(){
        if(this.isBotDetected()){
            this.setState({botDetected: true});
            return;
        }
        const email = this.state[this.email];
        const password = this.state[this.password];
        AuthApi.signUp(email, password, this);
        this.setState({loading: true, showError: false, showRecaptcha: false});
    }
    isBotDetected(){
        if(!Config.isHoneypotEnabled()){
            return false;
        }
        const email = this.emailRef.current.value;
        const name = this.nameRef.current.value;
        if(email.length <= 0 && name.length <= 0){
            return false;
        }
        var requestData = [];
        requestData.push({
            'activityType': "honeypot_submitted",
            'url': window.location.href,
            'data': {
                email: email,
                name: name
            }
        });
        
        Api.sendActivity(requestData);
        return true;
    }
    onSocialLogin(e, url){
        e.preventDefault();
        const queryString = window.location.search;
        if(queryString.length > 1){
            localStorage.setItem("mogli_query_params", queryString);
        }
        window.location.href = url;
    }
    onInactiveUserModalClose(){
        this.setState({
            inactiveUserModal: false,
            redirect: true,
            redirectUrl: "/login"
        });
        AuthApi.logout();
        this.props.dispatch({type: 'LOGOUT'});
    }
    render() {
        const { validation, loading, requestCode, showError, errorMessage, showRecaptcha } = this.state;
        const { /*requireLowerletter, requireUpperletter, requireNumber,*/ requireSymbol, requireLength, botDetected,inactiveUserModal } = this.state;
        const { authorized } = this.props.state;
        const showPasswordErrors = (validation.password === "success" || validation.password === "error");
        if(authorized){
            return <Navigate to='/' />
        }
        if(this.state.redirect && this.state.redirectUrl !== null){
            return <Navigate to={this.state.redirectUrl} />
        }
        const email = this.state[this.email];
        const password = this.state[this.password];
        const passwordConfirm = this.state[this.passwordConfirm];
        // const returnUrl = "/signup";
        // const amazonUrl = Config.getAmazonLoginUrl(returnUrl);
        // const googleUrl = Config.getGoogleLoginUrl(returnUrl);
        // const facebookUrl = Config.getFacebookLoginUrl(returnUrl);

        return (
            <SignupRoot
                className={classes.pageHeader}
            >
                <div className={classes.container}>
                    <GridContainer justifyContent="center">
                        <GridItem xs={12} sm={9} md={6} lg={5}>
                            {
                                this.redirecting ?
                                    <Card className={classes.signupCard}>
                                        <LoaderComponent align="center" />
                                    </Card>
                                :
                                <Card className={classes.signupCard}>
                                    <h5 className={classes.cardTitle + " " + classes.modalTitle}>Signup</h5>
                                    <CardBody signup>
                                        <GridContainer justifyContent="center">
                                            {/* <GridItem xs={12} sm={5} md={5}>
                                                <InfoArea
                                                className={classes.infoArea}
                                                title="Marketing"
                                                description="We've created the marketing campaign of the website. It was a very interesting collaboration."
                                                icon={Timeline}
                                                iconColor="rose"
                                                />
                                                <InfoArea
                                                className={classes.infoArea}
                                                title="Fully Coded in HTML5"
                                                description="We've developed the website with HTML5 and CSS3. The client has access to the code using GitHub."
                                                icon={Code}
                                                iconColor="primary"
                                                />
                                                <InfoArea
                                                className={classes.infoArea}
                                                title="Built Audience"
                                                description="There is also a Fully Customizable CMS Admin Dashboard for this product."
                                                icon={Group}
                                                iconColor="info"
                                                />
                                            </GridItem> */}
                                            <GridItem xs={12} >
                                                {/* <div className={classes.textCenter}>
                                                <Button justIcon round color="twitter">
                                                    <i
                                                    className={classes.socials + " fab fa-twitter"}
                                                    />
                                                </Button>
                                                {` `}
                                                <Button justIcon round color="dribbble">
                                                    <i
                                                    className={classes.socials + " fab fa-dribbble"}
                                                    />
                                                </Button>
                                                {` `}
                                                <Button justIcon round color="facebook">
                                                    <i
                                                    className={classes.socials + " fab fa-facebook-f"}
                                                    />
                                                </Button>
                                                {` `}
                                                <h4 className={classes.socialTitle}>
                                                    or be classical
                                                </h4>
                                                </div> */}
                                                {
                                                    botDetected ?
                                                        <p className={classes.textCenter}>Thanks!</p>
                                                    :
                                                        requestCode ?
                                                            <div>
                                                                <GridItem>
                                                                    <Warning>
                                                                        We just sent you a six digit verification code to your email address.  Enter it below to verify your account.
                                                                    </Warning>
                                                                </GridItem>
                                                                <GridContainer>
                                                                    <GridItem>
                                                                        {
                                                                            showError ?
                                                                            <GridItem className={"passwordCheck-notValid-customizable "+classes.verifyError}>
                                                                                <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#x2716;</span>
                                                                                <span className="checkPasswordText-lowerletter">{errorMessage}</span>
                                                                            </GridItem>
                                                                            :
                                                                            <></>
                                                                        }
                                                                        <form onSubmit={this.confirmSignUp} noValidate>
                                                                            <GridItem>                             
                                                                                <CustomInput
                                                                                    success={validation.code === "success"}
                                                                                    error={validation.code === "error"}
                                                                                    id="input-code"
                                                                                    inputProps={{
                                                                                        required: true,
                                                                                        onChange: (e) => this.handleChange(e,'code'),
                                                                                        name: "code",
                                                                                        type: "text",
                                                                                        startAdornment: (
                                                                                            <InputAdornment position="start" className={classes.inputAdornment} >
                                                                                                <VerifiedUser className={classes.inputAdornmentIcon}/>
                                                                                            </InputAdornment>
                                                                                        ),
                                                                                        placeholder:"Verification Code"
                                                                                    }}                                    
                                                                                    formControlProps={{
                                                                                        fullWidth: true
                                                                                    }}
                                                                                />
                                                                            </GridItem>                              
                                                                            <GridItem className={classes.textCenter}>
                                                                                {
                                                                                    loading ?
                                                                                        <LoaderComponent />
                                                                                    :
                                                                                        <>
                                                                                        <Button type="submit" color="primary" round>
                                                                                            <AuthIcon className={classes.icons} /> Confirm Account
                                                                                        </Button>
                                                                                        <p className="redirect-customizable text-center mt-2"><span>Didn't receive a code?</span>&nbsp;<span className={classes.anchor} onClick={(e) => this.resendCode(e)}>Resend it</span></p>
                                                                                        </>
                                                                                }
                                                                                
                                                                            </GridItem>
                                                                        </form>
                                                                    </GridItem>
                                                                </GridContainer>                        
                                                            </div>
                                                        :
                                                        <>
                                                            {
                                                                showError ?
                                                                <GridItem className={"passwordCheck-notValid-customizable"}>
                                                                    <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#x2716;</span>
                                                                    <span className="checkPasswordText-lowerletter">{errorMessage}</span>
                                                                </GridItem>
                                                                :
                                                                <></>
                                                            }
                                                            <form className={classes.form} onSubmit={this.handleSubmit}>
                                                                <CustomInput
                                                                    formControlProps={{
                                                                        fullWidth: true,
                                                                        className: classes.customFormControlClasses
                                                                    }}
                                                                    success={validation.email === "success"}
                                                                    error={validation.email === "error"}
                                                                    id={"input-"+this.email}
                                                                    inputProps={{
                                                                        onChange: (e) => this.handleChange(e, this.email),
                                                                        name: this.email,
                                                                        value: email,
                                                                        startAdornment: (
                                                                            <InputAdornment position="start" className={classes.inputAdornment} >
                                                                                <Email className={classes.inputAdornmentIcon}/>
                                                                            </InputAdornment>
                                                                        ),
                                                                        placeholder:"Email"
                                                                    }}
                                                                />
                                                                <CustomInput
                                                                    formControlProps={{
                                                                        fullWidth: true,
                                                                        className: classes.customFormControlClasses
                                                                    }}
                                                                    success={validation.password === "success"}
                                                                    error={validation.password === "error"}
                                                                    id={"input-"+this.password}                                        
                                                                    inputProps={{
                                                                        onChange: (e) => this.handleChange(e, this.password),
                                                                        name: this.password,
                                                                        type: "password",
                                                                        value: password,
                                                                        startAdornment: (
                                                                            <InputAdornment position="start" className={classes.inputAdornment}>
                                                                                <LockIcon className={classes.inputAdornmentIcon}></LockIcon>
                                                                            </InputAdornment>
                                                                        ),
                                                                        placeholder:"Password"
                                                                    }}
                                                                />
                                                                {
                                                                    showPasswordErrors ?
                                                                        <GridItem>
                                                                            <div>
                                                                                <div className={(requireSymbol?"passwordCheck-valid-customizable":"passwordCheck-notValid-customizable")+" checkPassword-symbols"}>
                                                                                    <span aria-hidden="true" className="validation-error-symbol check-numbers">{requireSymbol? '\u2713' : '\u2716' }</span>
                                                                                    <span className="checkPasswordText-numbers">Password must contain a special character</span>
                                                                                </div>
                                                                                <div className={(requireLength?"passwordCheck-valid-customizable":"passwordCheck-notValid-customizable")+" checkPassword-length"}>
                                                                                    <span aria-hidden="true" className="validation-error-symbol check-length">{requireLength? '\u2713' : '\u2716' }</span>
                                                                                    <span className="checkPasswordText-length">Password must contain at least 8 characters</span>
                                                                                </div>
                                                                            </div>
                                                                        </GridItem>
                                                                    :
                                                                    <></>
                                                                }
                                                                <CustomInput
                                                                    success={validation.passwordConfirm === "success"}
                                                                    error={validation.passwordConfirm === "error"}
                                                                    id={"input-"+this.passwordConfirm}
                                                                    inputProps={{
                                                                        required: true,
                                                                        onChange: (e) => this.handleChange(e, this.passwordConfirm),
                                                                        name: this.passwordConfirm,
                                                                        type: "password",
                                                                        value: passwordConfirm,
                                                                        placeholder:"Type Password Again",
                                                                        startAdornment: (
                                                                            <InputAdornment position="start" className={classes.inputAdornment}>
                                                                                <LockIcon className={classes.inputAdornmentIcon}></LockIcon>
                                                                            </InputAdornment>
                                                                        ),
                                                                    }}                                    
                                                                    formControlProps={{
                                                                        fullWidth: true,
                                                                        className: classes.customFormControlClasses+" "+classes.removeMargin
                                                                    }}
                                                                />
                                                                <p>
                                                                    Already Have an Account?{" "}
                                                                    <Link to="/login">Sign In</Link>
                                                                </p>
                                                                {/* <FormControlLabel
                                                                    classes={{label: classes.label}}
                                                                    control={
                                                                        <Checkbox                                                
                                                                            tabIndex={-1}
                                                                            onClick={(e) => this.handleCheckbox(e, "terms")}
                                                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                                                            icon={<Check className={classes.uncheckedIcon} />}
                                                                            classes={{checked: classes.checked, root: classes.checkRoot}}
                                                                            checked={this.state.terms}
                                                                        />
                                                                    }
                                                                    label={
                                                                        <span>
                                                                            I agree to the{" "}
                                                                            <Link to="/help/terms">terms and conditions</Link>.
                                                                        </span>
                                                                    }
                                                                /> */}
                                                                    
                                                                <div className={classes.botFields}>
                                                                    <label htmlFor="email">Email Address</label>
                                                                    <input type="email" name="email" id="email" autoComplete="off" ref={this.emailRef} />
                                                                    <label htmlFor="name">Name</label>
                                                                    <input type="text" name="name" id="name" autoComplete="off" ref={this.nameRef} />
                                                                </div>
                                                                <div className={classes.textCenter}>
                                                                    {
                                                                        loading ?
                                                                            <LoaderComponent />
                                                                        :
                                                                        validation.isValid ?
                                                                            showRecaptcha ?
                                                                                <></>
                                                                            :
                                                                            <Button round color="primary" type="submit" onClick={this.handleSubmit}>Get started</Button>
                                                                        :
                                                                            <Button round color="primary" type="submit" disabled>Get started</Button>
                                                                    }                                        
                                                                </div>
                                                                {/* {
                                                                    Config.isRecaptchaEnabled() ?
                                                                        <div className={classes.recaptcha+" RecaptchaV2 "+(showRecaptcha ? classes.showRecaptcha : "")}>
                                                                            <RecaptchaV2 onChange={(response) => this.onRecaptcha(response)} show={showRecaptcha} />
                                                                        </div>
                                                                    :
                                                                    <></>
                                                                } */}
                                                                {/* <div className={classes.textCenter+" "+classes.socialLinks}>
                                                                    <p>or use one of the following to create your account</p>
                                                                    <MaterialLink href={amazonUrl} underline="none" onClick={(e) => this.onSocialLogin(e, amazonUrl)}>
                                                                        <Button color="amazon">
                                                                            <AmazonIcon className={"MuiSvgIcon-root amazon-icon"} />
                                                                            Continue with Login with Amazon
                                                                        </Button>
                                                                    </MaterialLink>
                                                                    <MaterialLink href={googleUrl} underline="none" onClick={(e) => this.onSocialLogin(e, googleUrl)}>
                                                                        <Button color="google" className={classes.googleButton}>
                                                                            <GoogleIcon className={"MuiSvgIcon-root google-icon"} />
                                                                            Continue with Google
                                                                        </Button>
                                                                    </MaterialLink>
                                                                    <MaterialLink href={facebookUrl} underline="none" onClick={(e) => this.onSocialLogin(e, facebookUrl)}>
                                                                        <Button color="facebook">
                                                                            <FacebookIcon className={"MuiSvgIcon-root facebook-icon"} />
                                                                            Continue with Facebook
                                                                        </Button>
                                                                    </MaterialLink>
                                                                </div> */}
                                                            </form>
                                                        </>
                                                }
                                            </GridItem>
                                        </GridContainer>
                                    </CardBody>
                                </Card>
                            }
                            
                        </GridItem>
                    </GridContainer>
                </div>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    className={classes.snackbar}
                    open={this.state.codeResendNotice}
                    autoHideDuration={1000}
                    onClose={this.codeResendNotice}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id">Verification Code Resent!</span>}
                />
                {
                    inactiveUserModal ?
                        <InactiveUserModal
                            open={inactiveUserModal}
                            onClose={() => this.onInactiveUserModalClose()}
                        />
                    :
                    null
                }
            </SignupRoot>
        )
    }
}

export default connect(mapStateToProps)(Signup);